<template>
  <div class="dashboard-view">
    <div class="card border-0">
      <div class="card-body pt-0 pl-0 pr-0" style="background-color: #E3E8EE">
        <div class="general-info-wrapper">
          <!--          <amount-viewer :title="$t('Sold Items')" text-class="text-success" :icon="'boxes'" :clickable="true"-->
          <!--                         @click="onSoldLotsClick"-->
          <!--                         v-animate-fade="0.2" :amount="generalInfoData.sold_lots" :loading="generalInfoLoader"/>-->
          <!--          <amount-viewer :title="$t('Unsold Items')" text-class="text-danger" :icon="'boxes'" :clickable="true"-->
          <!--                         @click="onUnsoldLotsClick"-->
          <!--                         v-animate-fade="0.3" :amount="generalInfoData.unsold_lots" :loading="generalInfoLoader"/>-->
          <amount-viewer :title="$t('Total Invoices')" :amount="generalInfoData.invoices" :clickable="true"
                         @click="onTotalInvoicesClick"
                         v-animate-fade="0.4" :icon="'file-invoice'" :loading="generalInfoLoader"/>
          <amount-viewer :title="$t('Invoice Amount')" :icon="'money-bill'" :clickable="true"
                         @click="onInvoiceAmountClick"
                         v-animate-fade="0.6" :amount="generalInfoData.invoice_amount" :loading="generalInfoLoader"/>
          <amount-viewer :title="$t('Paid Invoice Amount')" :icon="'money-bill'" :clickable="true"
                         @click="onPaidInvoiceAmountClick"
                         v-animate-fade="0.7" :amount="generalInfoData.paid_invoice_amount"
                         :loading="generalInfoLoader"/>
          <amount-viewer :title="$t('Outstanding Invoice Amount')" :icon="'money-bill'" :clickable="true"
                         @click="onOutstandingInvoiceAmountClick"
                         v-animate-fade="0.7" :amount="generalInfoData.outstanding_invoice_amount"
                         :loading="generalInfoLoader"/>

          <amount-viewer :title="$t('Total Settlements')" :amount="generalInfoData.settlements" :clickable="true"
                         @click="onTotalSettlementsClick"
                         v-animate-fade="0.4" :icon="'file-invoice'" :loading="generalInfoLoader"/>
          <amount-viewer :title="$t('Settlement Amount')" :icon="'money-bill'" :clickable="true"
                         @click="onSettlementAmountClick"
                         v-animate-fade="0.6" :amount="generalInfoData.settlement_amount" :loading="generalInfoLoader"/>
          <amount-viewer :title="$t('Paid Settlement Amount')" :icon="'money-bill'" :clickable="true"
                         @click="onPaidSettlementAmountClick"
                         v-animate-fade="0.7" :amount="generalInfoData.paid_settlement_amount"
                         :loading="generalInfoLoader"/>
          <amount-viewer :title="$t('Outstanding Settlement Amount')" :icon="'money-bill'" :clickable="true"
                         @click="onOutstandingSettlementAmountClick"
                         v-animate-fade="0.7" :amount="generalInfoData.outstanding_settlement_amount"
                         :loading="generalInfoLoader"/>

        </div>
        <div class="main-wrapper">
          <div class="card" v-animate-fade="0.2">
            <div class="card-header d-flex align-items-center">
              <h5 class="d-inline-block mb-0">{{ $t('Customer Information') }}</h5>
              <b-button class="ml-auto p-0" variant="link" v-permission="'change_customer'"
                        @click="onEditClick(customer)">
                <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                {{ $t('Edit') }}
              </b-button>
            </div>
            <div class="card-body pt-2 pb-0">
              <customer-info-table :customer="customer" :enableCustomerLink="false"/>
            </div>
          </div>
          <div class="nested-grid">
<!--            <customer-links class="customer-links-card"-->
<!--                            :delete-permission="'delete_customer'"-->
<!--                            :change-permission="'change_customer'"-->
<!--                            v-animate-fade="0.2"></customer-links>-->
            <div class="wrapper address-card" v-animate-fade="0.5" v-if="$hasPermission('view_customeraddress')">
              <address-viewer
                  class="h-100"
                  key="dashboard-billing-address"
                  :header-text="$t('Billing Address')"
                  :with-actions="false"
                  :hide-icon="true"
                  :source="SOURCE_CUSTOMER_DASHBOARD"
                  :show-edit-action="!!($hasPermission('change_customeraddress') && billingAddress)"
                  :show-create-action="!!($hasPermission('change_customeraddress') && !billingAddress)"
                  :address="billingAddress || {}"
                  :type="'billing'"
                  :loader="addressesLoader"
              />
            </div>
            <div class="wrapper address-card" v-animate-fade="0.5" v-if="$hasPermission('view_customeraddress')">
              <address-viewer
                  class="h-100"
                  key="dashboard-shipping-address"
                  :header-text="$t('Shipping/Collection Address')"
                  :with-actions="false"
                  :hide-icon="true"
                  :source="SOURCE_CUSTOMER_DASHBOARD"
                  :show-edit-action="!!($hasPermission('change_customeraddress') && shippingAddress)"
                  :show-create-action="!!($hasPermission('change_customeraddress') && !shippingAddress)"
                  :address="shippingAddress || {}"
                  :type="'shipping'"
                  :loader="addressesLoader"
              />
            </div>
            <balance-view-card :title="$t('Deposits')" :customer="customer" v-animate-fade="0.2"
                               class="customer-balance-card"/>
            <div class="card notes-card" v-animate-fade="0.7">
              <div class="card-header d-flex align-items-center">
                <h5 class="mb-0">{{ $t('Latest Notes') }}</h5>
                <b-button v-if="hasExtraNotes" class="p-0 ml-auto" variant="link" :to="{name: 'customers.notes'}">
                  {{ $t('View More') }}
                </b-button>
              </div>
              <div class="card-body pt-0 pb-0">
                <spinner :with-text="false" :show="latestNotesLoader" height="8"/>
                <template v-if="!latestNotesLoader">
                  <div v-for="(latestNote, index) in latestNotes" :key="`latest-note-${index}`" class="pb-2 pt-2"
                       :class="{'border-bottom': index < latestNotes.length - 1}">
                    {{ latestNote.description | striptags }}
                  </div>
                  <no-data-available v-if="!latestNotesLoader && latestNotes.length === 0" :height="10"/>
                </template>
              </div>
            </div>
          </div>

          <div class="card relations-card" v-if="enableNlRelations">
            <div class="card-header">
              <h5 class="mb-0">{{ $t("Relations") }}</h5>
            </div>
            <div class="card-body">
              <spinner :with-text="false" height="5" show v-if="relations.loader"/>
              <table v-else class="table table-sm">
                <tr>
                  <th class="border-top-0"></th>
                  <th class="border-top-0">{{ $t('Customer') }}</th>
                  <th class="border-top-0">{{ $t('Confirmations') }}</th>
                  <th class="border-top-0">{{ $t('Suggestions') }}</th>
                  <th class="border-top-0">{{ $t('Settlements') }}</th>
                  <th class="border-top-0">{{ $t('Remove from CC') }}</th>
                  <th class="border-top-0">{{ $t('Reference Number') }}</th>
                  <th class="border-top-0">{{ $t('Intermediary Commission Rate') }}</th>
                  <th class="border-top-0">{{ $t('Including VAT') }}</th>
                  <th class="border-top-0"></th>
                </tr>
                <tr class="hover">
                  <th>{{ $t("Notary") }}</th>
                  <td>
                    <template v-if="relations.notary && relations.notary.related_customer">
                      <router-link v-if="relations.notary.related_customer"
                                   :to="{ name: 'customers.dashboard', params: { id: relations.notary.related_customer.uuid }}">
                        {{ relations.notary.related_customer.display_name }}
                      </router-link>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.notary">
                      <span class="badge badge-success" v-if="relations.notary.confirmations">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.notary">
                      <span class="badge badge-success" v-if="relations.notary.suggestions">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.notary">
                      <span class="badge badge-success" v-if="relations.notary.settlements">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.notary">
                      <span class="badge badge-success" v-if="relations.notary.cc">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.notary">
                      {{ relations.notary.reference_number }}
                    </template>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <b-button v-permission="'change_customer'" variant="primary" size="sm"
                              @click="onRelationEditClick('notary')">
                      <font-awesome-icon :icon="'pen'"></font-awesome-icon>
                    </b-button>
                    <b-button v-permission="'change_customer'" variant="danger" size="sm"
                              v-if="relations && relations.notary"
                              @click="onRelationDeleteClick('notary')" class="ml-2">
                      <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                    </b-button>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("Intermediary") }}</th>
                  <td>
                    <template v-if="relations.intermediary && relations.intermediary.related_customer">
                      <router-link v-if="relations.intermediary.related_customer"
                                   :to="{ name: 'customers.dashboard', params: { id: relations.intermediary.related_customer.uuid }}">
                        {{ relations.intermediary.related_customer.display_name }}
                      </router-link>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.intermediary">
                      <span class="badge badge-success" v-if="relations.intermediary.confirmations">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.intermediary">
                      <span class="badge badge-success" v-if="relations.intermediary.suggestions">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.intermediary">
                      <span class="badge badge-success" v-if="relations.intermediary.settlements">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.intermediary">
                      <span class="badge badge-success" v-if="relations.intermediary.cc">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.intermediary">
                      {{ relations.intermediary.reference_number }}
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.intermediary">
                      {{ getIntermediaryRate(relations.intermediary.intermediary_commission_rate) | asPercentage }}
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.intermediary">
                      <span class="badge badge-success" v-if="relations.intermediary.including_vat">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <b-button v-permission="'change_customer'" variant="primary" size="sm"
                              @click="onRelationEditClick('intermediary')">
                      <font-awesome-icon :icon="'pen'"></font-awesome-icon>
                    </b-button>
                    <b-button v-permission="'change_customer'" variant="danger" size="sm"
                              v-if="relations && relations.intermediary"
                              @click="onRelationDeleteClick('intermediary')" class="ml-2">
                      <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                    </b-button>
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("Contact Person") }}</th>
                  <td>
                    <template v-if="relations.contactPerson && relations.contactPerson.related_customer">
                      <router-link v-if="relations.contactPerson.related_customer"
                                   :to="{ name: 'customers.dashboard', params: { id: relations.contactPerson.related_customer.uuid }}">
                        {{ relations.contactPerson.related_customer.display_name }}
                      </router-link>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.contactPerson">
                      <span class="badge badge-success" v-if="relations.contactPerson.confirmations">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.contactPerson">
                      <span class="badge badge-success" v-if="relations.contactPerson.suggestions">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.contactPerson">
                      <span class="badge badge-success" v-if="relations.contactPerson.settlements">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.contactPerson">
                      <span class="badge badge-success" v-if="relations.contactPerson.cc">
                        {{ $t('Yes') }}
                      </span>
                      <span class="badge badge-danger" v-else>{{ $t('No') }}</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="relations.contactPerson">
                      {{ relations.contactPerson.reference_number }}
                    </template>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <b-button v-permission="'change_customer'" variant="primary" size="sm"
                              @click="onRelationEditClick('contact_person')">
                      <font-awesome-icon :icon="'pen'"></font-awesome-icon>
                    </b-button>
                    <b-button v-permission="'change_customer'" variant="danger" size="sm"
                              v-if="relations && relations.contactPerson"
                              @click="onRelationDeleteClick('contact_person')" class="ml-2">
                      <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                    </b-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="card" v-animate-fade="0.4">
            <div class="card-header d-flex align-items-center">
              <h5 class="d-inline-block mb-0">{{ $t('Customer Interests') }}</h5>
              <b-form-group class="d-inline-block mb-0 ml-auto">
                <b-form-radio-group
                  id="btn-radios-3"
                  size="sm"
                  v-model="customerInterestsCustomerType"
                  :options="typeOptions"
                  buttons
                  button-variant="outline-primary"
                  name="radio-btn-stacked"></b-form-radio-group>
              </b-form-group>
            </div>
            <no-data-available
              v-if="!customerInterestsLoader && customerInterestsData.labels && !customerInterestsData.labels.length"
              :height="10"/>
            <div v-else class="card-body d-flex align-items-center justify-content-center">
              <spinner :with-text="false" height="15" :show="customerInterestsLoader"/>
              <e-pie-chart v-if="!customerInterestsLoader && customerInterestsData && customerInterestsData.length > 0"
                           :chart-data="customerInterestsData"/>
              <no-data-available v-if="customerInterestsData && customerInterestsData.length === 0"/>
            </div>
          </div>
          <div class="card" v-animate-fade="0.4">
            <div class="card-header d-flex align-items-center">
              <h5 class="d-inline-block mb-0">{{ $t('Financial Activity') }}</h5>
              <b-form-group class="d-inline-block mb-0 ml-auto">
                <b-form-radio-group
                  id="btn-radios-3"
                  size="sm"
                  v-model="financialActivityCustomerType"
                  :options="typeOptions"
                  buttons
                  button-variant="outline-primary"
                  name="radio-btn-stacked"></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="card-body d-flex align-items-center justify-content-center">
              <spinner :with-text="false" height="28" :show="financialActivityLoader"/>
              <template v-if="!financialActivityLoader">
                <e-line-chart
                  v-if="financialActivityData && financialActivityData.labels && financialActivityData.labels.length > 0"
                  :chart-data="financialActivityData"/>
                <no-data-available v-else height="10"/>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomerLinks from "./customer-links/CustomerLinks";
  import {createNamespacedHelpers} from 'vuex';
  import AddressViewer from "./../addresses/AddressViewer";
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import Spinner from "../../../../core/components/common/Spinner";
  import {SOURCE_CUSTOMER_DASHBOARD} from "../../../constants";
  import i18n from './../../../../shared/i18n'
  import CustomerInfoTable from "./CustomerInfoTable";
  import AmountViewer from "../../../../core/components/common/AmountViewer";
  import _ from 'lodash';
  import {ON_CUSTOMER_DASHBOARD_DATE_CHANGE} from "@/plugins/event-bus/event-bus-names";
  import BalanceViewCard from "../balance/BalanceViewCard";
  import EPieChart from "@/core/components/charts/EPieChart";
  import ELineChart from "@/core/components/charts/ELineChart";
  import RelationsService from "@/modules/relations/RelationsService";
  import {hasPermission} from "@/core/directives/permission";

  const {mapActions: customerMapActions} = createNamespacedHelpers('customer');
  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapActions: inventoryMapActions} = createNamespacedHelpers('inventory')
  const {mapActions: invoiceMapActions} = createNamespacedHelpers('invoices');
  const {mapActions: settlementsMapActions} = createNamespacedHelpers('settlements');
  const {mapGetters: globalMapGetters, mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "DashboardView",
    components: {
      ELineChart,
      EPieChart,
      BalanceViewCard,
      AmountViewer, CustomerInfoTable, Spinner, NoDataAvailable, AddressViewer, CustomerLinks
    },
    data: () => {
      return {
        SOURCE_CUSTOMER_DASHBOARD: SOURCE_CUSTOMER_DASHBOARD,
        typeOptions: [
          {text: i18n.t('Vendor'), value: 'vendor', disabled: false},
          {text: i18n.t('Buyer'), value: 'buyer', disabled: false},
        ],
        selectedYear: '1',
        customerInterestsCustomerType: 'vendor',
        financialActivityCustomerType: 'vendor',
      };
    },
    methods: {
      ...mapActions([
        'getDashboardRelations',
        'getDashboardAddresses',
        'getDashboardLatestNotes',
        'getDashboardCustomerLinks',
        'resetDashboardData',
        'getDashboardGeneralInfo',
        'getDashboardCustomerInterests',
        'getDashboardCustomerFinancialActivity',
        'getAddressListAddresses',
        'showRelationModal',
      ]),
      ...customerMapActions(['showModal', 'getModalObject']),
      ...inventoryMapActions({
        updateTableSourceInventory: 'updateTableSource',
        updateSearchModelInventory: 'updateSearchModel',
        resetSearchModelInventory: 'resetSearchModel',
      }),
      ...invoiceMapActions({
        updateTableSourceInvoice: "updateTableSource",
        updateSearchModelInvoice: "updateSearchModel",
        resetSearchModelInvoice: "resetSearchModel"
      }),
      ...settlementsMapActions({
        updateTableSourceSettlement: "updateTableSource",
        updateSearchModelSettlement: "updateSearchModel",
        resetSearchModelSettlement: "resetSearchModel"
      }),
      sendRequest() {
        let params = {
          customer_uuid: this.customer.uuid,
          year: this.selectedYear
        };

        this.getDashboardGeneralInfo(params);
        this.getDashboardCustomerInterests(params);
        this.getDashboardCustomerFinancialActivity(params);
      },
      onEditClick(item) {
        this.showModal();
        this.getModalObject({uuid: item.uuid, source: SOURCE_CUSTOMER_DASHBOARD});
      },

      goToInventoryWithCurrentCustomerAndStatusOf(status) {
        this.updateTableSourceInventory({source: "inventory"})
        this.resetSearchModelInventory()
        this.updateSearchModelInventory({status, customer_uuid: this.$route.params.id, customer: this.customer})
        this.$router.push({name: "inventory"})
      },
      onSoldLotsClick() {
        this.goToInventoryWithCurrentCustomerAndStatusOf(['sold', 'manually_sold'])
      },
      onUnsoldLotsClick() {
        this.goToInventoryWithCurrentCustomerAndStatusOf(['unsold'])
      },
      goToInvoicesWithCurrentCustomerAndOptionalParams(params = {}) {
        this.updateTableSourceInvoice({source: "invoices"})
        this.resetSearchModelInvoice()
        this.updateSearchModelInvoice({
          searchModel: {
            customer_uuid: this.$route.params.id,
            customer: this.customer, ...params
          }
        })
        this.$router.push({name: "invoices"})
      },
      onTotalInvoicesClick() {
        this.goToInvoicesWithCurrentCustomerAndOptionalParams({status: ['paid', 'unpaid']})
      },
      onInvoiceAmountClick() {
        this.goToInvoicesWithCurrentCustomerAndOptionalParams({status: ['paid', 'unpaid']})
      },
      onPaidInvoiceAmountClick() {
        this.goToInvoicesWithCurrentCustomerAndOptionalParams({status: ['paid']})
      },
      onOutstandingInvoiceAmountClick() {
        this.goToInvoicesWithCurrentCustomerAndOptionalParams({status: ['unpaid']})
      },
      onTotalSettlementsClick() {
        this.goToSettlementWithCurrentCustomerAndOptionalParams({status: ['paid', 'unpaid']})
      },
      onSettlementAmountClick() {
        this.goToSettlementWithCurrentCustomerAndOptionalParams({status: ['paid', 'unpaid']})
      },
      onPaidSettlementAmountClick() {
        this.goToSettlementWithCurrentCustomerAndOptionalParams({status: ['paid']})
      },
      onOutstandingSettlementAmountClick() {
        this.goToSettlementWithCurrentCustomerAndOptionalParams({status: ['unpaid']})
      },
      goToSettlementWithCurrentCustomerAndOptionalParams(params = {}) {
        this.updateTableSourceSettlement({source: "settlements"})
        this.resetSearchModelSettlement()
        this.updateSearchModelSettlement({
          customer_uuid: this.$route.params.id,
          customer: this.customer,
          ...params
        })
        this.$router.push({name: "settlements"})
      },
      onRelationEditClick(relationType) {
        let obj = {};

        if (relationType === 'notary' && this.relations.notary) {
          obj = this.relations.notary
        } else if (relationType === 'contact_person' && this.relations.contactPerson) {
          obj = this.relations.contactPerson
        } else if (relationType === 'intermediary' && this.relations.intermediary) {
          obj = this.relations.intermediary
        }

        this.showRelationModal({
          source: SOURCE_CUSTOMER_DASHBOARD,
          object: {
            object_uuid: this.customer.uuid,
            type: relationType,
            ...obj
          },
          relationType
        })
      },
      async onRelationDeleteClick(relationType) {
        let obj = null;

        if (relationType === 'notary' && this.relations.notary) {
          obj = this.relations.notary
        } else if (relationType === 'contact_person' && this.relations.contactPerson) {
          obj = this.relations.contactPerson
        } else if (relationType === 'intermediary' && this.relations.intermediary) {
          obj = this.relations.intermediary
        }

        if (obj) {

          let success = await this.$confirm(this.$i18n.t("Are you sure you want to remove following relation?"))
          if (!success) {
            return;
          }

          let response = await RelationsService.removeRelation(obj.uuid);
          if (response.success) {
            this.$toast('success', this.$i18n.t("Relation was successfully deleted"));
            this.getDashboardRelations();
          }
        }
      },
      getIntermediaryRate(rate) {
        // if (this.inclusiveTiersEnabled && this.currentBranch) {
        //   if (rate) {
        //     return parseFloat(rate * (this.currentBranch.tax_rate / 100 + 1)).toFixed()
        //   }
        // }
        return rate
      }
    },
    computed: {
      ...globalMapGetters(['isIntermediaryCustomerTypesEnabled']),
      ...globalMapState(['currentBranch', 'inclusiveTiersEnabled', 'enableNlRelations']),
      ...mapState({
        customer: state => state.customer,
        addressesLoader: state => state.dashboardData.addressesLoader,
        latestNotesLoader: state => state.dashboardData.latestNotesLoader,
        billingAddress: state => state.dashboardData.billingAddress,
        shippingAddress: state => state.dashboardData.shippingAddress,
        latestNotes: state => state.dashboardData.latestNotes,
        hasExtraNotes: state => state.dashboardData.hasExtraNotes,

        dashboardData: state => state.dashboardData,
        generalInfoData: state => state.dashboardData.generalInfo.data,
        generalInfoLoader: state => state.dashboardData.generalInfo.loader,

        customerInterests: state => state.dashboardData.customerInterests,
        customerInterestsLoader: state => state.dashboardData.customerInterests.loader,

        financialActivity: state => state.dashboardData.financialActivity,
        financialActivityLoader: state => state.dashboardData.financialActivity.loader,
        relations: state => state.dashboardData.relations,
      }),

      customerInterestsData() {
        return _.cloneDeep(this.customerInterests[this.customerInterestsCustomerType]);
      },
      financialActivityData() {
        return _.cloneDeep(this.financialActivity[this.financialActivityCustomerType]);
      },
      balanceInfo() {
        if (!this.customer || !this.customer.deposits || this.customer.deposits.length === 0) {
          return {
            balance: this.$options.filters.asCurrency(0),
            available_balance: this.$options.filters.asCurrency(0),
            blocked: this.$options.filters.asCurrency(0),
          }
        }

        let balance = [];
        let available_balance = [];
        let blocked = [];

        for (let deposit of this.customer.deposits) {
          balance.push(this.$options.filters.asCurrency(deposit.balance, deposit.currency.symbol));
          available_balance.push(this.$options.filters.asCurrency(deposit.available_balance, deposit.currency.symbol));
          blocked.push(this.$options.filters.asCurrency(deposit.blocked, deposit.currency.symbol));
        }

        return {
          balance: balance.join(' / '),
          available_balance: available_balance.join(' / '),
          blocked: blocked.join(' / ')
        }
      }
    },
    async mounted() {
      await this.resetDashboardData();
      if (hasPermission('view_customeraddress')) {
        this.getDashboardAddresses();
        this.getAddressListAddresses();
      }
      this.getDashboardRelations();
      this.getDashboardLatestNotes();
      this.getDashboardCustomerLinks();

      // this.initTypes();
      this.sendRequest();
    },
    beforeMount() {
      this.$evBus.$on(ON_CUSTOMER_DASHBOARD_DATE_CHANGE, (year) => {
        this.selectedYear = year;
        this.sendRequest()
      });
    },
    beforeDestroy() {
      this.$evBus.$off(ON_CUSTOMER_DASHBOARD_DATE_CHANGE);
    },
  }
</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";

  .general-info-wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1em;
  }

  .main-wrapper {
    margin-top: 1em;
    display: grid;
    grid-gap: 1em;
    grid-template-columns: 2fr 3fr;

    .relations-card {
      grid-column: 1/3;
    }

    .nested-grid {
      display: grid;
      grid-gap: 1em;
      grid-template-columns: 1fr 1fr;

      .customer-links-card {
        grid-column: 1/3;
      }

      .customer-balance-card {
        //grid-column: 1/2;
      }

      .notes-card {
        //grid-column: 1/3;
      }
    }
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "xl")) {
    .general-info-wrapper {
      grid-template-columns: repeat(3, 2fr);
    }
    .main-wrapper {
      grid-template-columns: 2fr 2fr;

      .relations-card {
        grid-column: 1/2;
      }

      .nested-grid {
        .address-card {
          grid-column: 1/3;
        }

        .customer-links-card {
          grid-column: 1/3;
        }

        .customer-balance-card {
          grid-column: 1/3;
        }

        .notes-card {
          grid-column: 1/3;
        }
      }
    }
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    .main-wrapper {
      grid-template-columns: 2fr;
    }
  }

</style>
